'use client';

import cloudflareLoader from 'imageLoader';
import Image from 'next/image';

export const ClientSideImage = ({ alt, src }: { alt: string; src: string }) => (
  <Image
    loader={cloudflareLoader}
    alt={alt}
    src={src}
    width={600}
    height={600}
    style={{
      maxWidth: '100%',
      height: 'auto',
    }}
  />
);
